import useJob from "hooks/useJob";
import { useSearchParams } from "react-router-dom";
import EditJob from "./EditJob";

export default function EditJopPage() {
  const searchParams = useSearchParams()[0];

  const jobId = searchParams.get("jobId");

  const { isLoading, data } = useJob(jobId!);

  return (
    <>
      {isLoading ? (
        <div className="flex flex-col justify-center items-center"></div>
      ) : (
        <EditJob job={data?.data!} />
      )}
    </>
  );
}
